<template>
	<div class="zoom-oauth-callback">
		<socket size="112px"></socket>
	</div>
</template>

<script>
import storage from "@teaming/common-storage";
import { alertFactory } from "@teaming/common-ui";


export default {
	name: "ZoomOauthCallback",
	data() {
		return {
			alertError: null,
			alertSuccess: null,
		};
	},
	methods: {
		initializeAlertFactory() {
			const { i18n, } = this.$foundation();
			const { error, success, } = alertFactory( "slice-apple.components.ZoomOauthCallback", i18n.global.t );
			this.alertError = error;
			this.alertSuccess = success;
		},
		redirectToUrl() {
			const { config, } = this.$foundation();
			const redirectToUrl = storage.getRedirectToUrl() || config.appBaseUrl;
			const redirectToTarget = storage.getRedirectToTarget() || '_self';
			const teamingWindow = window.open(redirectToUrl, redirectToTarget);
			teamingWindow.focus();
			storage.removeRedirectToUrl();
			storage.removeRedirectToTarget();
			if (redirectToTarget !== '_self') {
				window.close();
			}
		},
	},
	async mounted() {
		this.initializeAlertFactory();
		const { code, } = this.$route.query;
		const { ioUser, } = this.$foundation();

		try {
			await ioUser.saveUserProfile( { zoomOauthCode: code, } );
			this.alertSuccess( "zoomOauthSuccess" );
			this.redirectToUrl();
		} catch ( e ) {
			this.alertError( "zoomOauthError" );
			// eslint-disable-next-line no-console
			console.error( "ZoomOauthCallback", e.message );
			this.redirectToUrl();
		}
	},
};
</script>

<style lang="scss" scoped>
.zoom-oauth-callback {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
